'use client';

import type { QuestionFormProps } from './QuestionForm.types';
import { Flex } from '@/_components';
import { QuestionActions } from './components/QuestionActions';
import { QuestionActionsUpload } from './components/QuestionActionsUpload';
import { QuestionFormSwitch } from './components/QuestionFormSwitch';
import { type FC } from 'react';

export const QuestionForm: FC<QuestionFormProps> = ({
  isDisabled,
  mode,
  question,
}) => {
  return (
    <Flex isColumn={true} gap={12}>
      <QuestionFormSwitch
        question={question}
        isDisabled={isDisabled}
        mode={mode}
      />
      {question.question_type === 'upload' ? (
        <QuestionActionsUpload
          question={question}
          attached_document={question.document_link || ''}
          isDisabled={isDisabled}
          mode={mode}
        />
      ) : (
        <QuestionActions
          question={question}
          isDisabled={isDisabled}
          mode={mode}
        />
      )}
    </Flex>
  );
};
